export const FILE_DOWNLOAD_FORMATS = {
	CSV: 'csv',
	EXCEL: 'excel',
	PDF: 'pdf',
};

// Optional: freeze it so it can't be accidentally modified
Object.freeze(FILE_DOWNLOAD_FORMATS);
